<template>
  <a-layout>
    <a-layout-footer id="hm-footer">
      <div class="hm-footer-btn">
        <span class="hm-footer-btn-item" @click="toDo('help')">帮助</span>
        <span class="hm-footer-btn-item" @click="toDo('privacy')">隐私</span>
        <span class="hm-footer-btn-item" @click="toDo('clause')">条款</span>
      </div>
      <!-- <div class="hm-footer-copyright" style="margin-top:1em;">Copyright &nbsp; @ &nbsp; 2020 北京毫末科技有限公司出品</div>
      <div class="hm-footer-copyright">备案信息：<a href="https://beian.miit.gov.cn">京ICP备17032665号-9</a></div> -->
    </a-layout-footer>
  </a-layout>

</template>

<script>
  export default {
    name: "HmFooter",
    methods: {
      toDo(type) {
        console.log(type);
      }
    }
  }
</script>

<style scoped>
  #hm-footer {
    /*height: 160px;*/
    background-color: #F5F5F5;
    bottom: 0;
    width: 100%;
    text-align: center;
    position: relative;
  }

  #hm-footer .hm-footer-btn {
    margin-top: 25px;
  }

  #hm-footer .hm-footer-btn-item {
    margin: 0 15px;
  }

  #hm-footer .hm-footer-copyright {
    width: 100%;
    line-height: 30px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    font-family: PingFangSC-Regular;
  }

</style>